import React from "react";
import { Box, Typography } from "@mui/material";

const PreviewMeta = ({ data }) => (
  <Box>
    <Typography variant="body2" fontWeight={600}>
      {data.title || "—"}
    </Typography>
    <Typography variant="caption" color="text.secondary">
      /{data.slug || "—"}
    </Typography>
  </Box>
);

export default PreviewMeta;